import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Stack, Typography } from "@mui/material";

export const Warning = () => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: 4,
        backgroundColor: "grey.300",
        padding: 3,
        borderRadius: 2,
        width: "100%",
        alignItems: "center",
      }}
    >
      <WarningAmberIcon />

      <Typography variant="body2">
        Important: Ensure you add the chain to MetaMask before initiating any
        bridging from it
      </Typography>
    </Stack>
  );
};
